export const Dialects = {
  POSTGRES: 'postgres',
  MSSQL: 'mssql',
  MYSQL: 'mysql',
} as const;
